import { CollectionPersistenceModel } from '../../data-layer/collections/types';
import { CollectionPersistenceUI } from '../../ui/users/types';

export const toCollectionPersistenceModel = (
    ui: CollectionPersistenceUI,
): CollectionPersistenceModel => ({
    id: ui.id,
    displayName: ui.displayName,
    isPublic: ui.isPublic,
});
